<a (click)="toggle()">
  <input type="checkbox"
         [(ngModel)]="control.value"
         #name="ngModel"
         [required]="control.required"
         [name]="control.name"
         #checkbox
  >
  <i antIcon type="check-circle" [theme]="theme"></i>&nbsp;
  <span appTranslate="{{ control.placeholder }}"></span>
</a>
